
import paginationMixin from '~/mixins/pagination';
import promiseErrors from '~/services/promiseErrors';

export default {
    name: 'GroupMembers',
    mixins: [paginationMixin],
    async asyncData({
        app,
        error,
        route,
    }) {
        const [group, members] = await promiseErrors([
            app.$axios.$get(`${app.$config.endpoints.group}/${route.params.slug}`),
            app.$axios.$get(`${app.$config.endpoints.group}/${route.params.slug}/users`, { params: { page: route.query.page || 1 } }),
        ], app);

        if (!group) {
            return error({ statusCode: 404, message: app.i18n.t('groups.not_found') });
        }

        return {
            group: group.group,
            members: members ? members.users.data : {},
            isMember: group.is_member,
            isSubscribed: group.is_subscribed,
            pagination: {
                current: members ? members.users.current_page : 1,
                total: members ? members.users.last_page : 1,
            },
        };
    },
    data() {
        return {
            group: {},
            events: [],
            members: [],
            isMember: false,
            isSubscribed: false,
        };
    },
    head() {
        return {
            title: `${this.$t('groups.meta.members', { group: this.group.title })} - ClearWaste`,
            meta: [
                { hid: 'description', name: 'description', content: this.group.description.substring(0, 150) },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: `${this.group.title} ${this.$t('groups.labels.members')} - ClearWaste`,
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.group.description.substring(0, 150),
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.group.image ? this.group.image.large : null,
                },
                {
                    hid: 'og:url',
                    proprty: 'og:url',
                    content: `${this.$config.domain}${this.$route.path}`,
                },
            ],
        };
    },
    methods: {
        updateMembership(membership) {
            this.isMember = membership;
        },
    },
};
